<h3>Log Call</h3>
<app-outbound-fax-selector (selectionChange)="onOutboundFaxChange($event)" />
@if (inboundCallFormModel.outboundFaxId) {
  <form (ngSubmit)="onSubmit()" novalidate>
    <div class="p-2 border rounded">
      <h4>Outcome</h4>
      <div><strong>Please log the outcome of this call</strong></div>
      @for (inboundCallReasonOption of inboundCallReasonOptions; track inboundCallReasonOption) {
        <div class="form-check mt-1">
          <input
            [id]="inboundCallReasonOption.value"
            name="status"
            class="form-check-input"
            type="radio"
            [value]="inboundCallReasonOption.value"
            (change)="onReasonChange()"
            [(ngModel)]="inboundCallFormModel.reason"
            />
          <label class="form-check-label" [for]="inboundCallReasonOption.value">
            {{ inboundCallReasonOption.display }}
          </label>
        </div>
      }
      <div class="my-2">
        <label for="notes" class="my-1">ADDITIONAL DETAILS</label>
        @if (!showNotes) {
          <fa-icon [icon]="['fas', 'plus-square']" size="sm" (click)="onNotesPlusClick()" />
        }
        @if (showNotes) {
          <fa-icon [icon]="['fas', 'minus-square']" size="sm" (click)="onNotesMinusClick()" />
        }
        @if (showNotes) {
          <textarea
            id="notes"
            name="notes"
            class="form-control phi"
            [(ngModel)]="inboundCallFormModel.notes"
            rows="4"
            >
          </textarea>
        }
      </div>
    </div>
    <div class="p-2 border rounded mt-2">
      <div class="mb-3 my-2">
        <h4>Update Communication Method</h4>
        @for (communicationMethod of communicationMethods; track communicationMethod) {
          <div class="form-check">
            <fieldset>
              <input
                type="radio"
                [id]="communicationMethod.value"
                name="communicationMethod"
                class="form-check-input"
                [(ngModel)]="inboundCallFormModel.communicationMethod"
                [value]="communicationMethod.value"
                />
              <label [for]="communicationMethod.value" class="form-check-label"> {{ communicationMethod.display }} </label>
            </fieldset>
          </div>
        }
      </div>
    </div>
    @if (validationErrors.length > 0) {
      <div class="alert alert-danger text-danger mt-2">
        <ul class="py-2">
          @for (error of validationErrors; track error) {
            <li>{{ error }}</li>
          }
        </ul>
      </div>
    }
    @if (serverError) {
      <div class="alert alert-danger text-danger mt-2 p-2">
        A server error occurred. Please try again or contact support.
      </div>
    }
    <div class="text-end actions mt-2">
      <button type="submit" class="btn btn-primary">Save</button>
      <a routerLink="/capture-admin/communications/inbound-calls" class="btn btn-secondary">Cancel</a>
    </div>
  </form>
}
